import type { TicketPublic } from '@ifsuv/shared';

/**
 * Fetch direct (sans cookie session). La page publique est accessible sans auth.
 */
export async function fetchPublicTicket(token: string): Promise<TicketPublic> {
  // no-store : évite qu'un 404 transitoire (fenêtre de déploiement) reste servi
  // depuis le cache du navigateur au re-scan du QR.
  const res = await fetch(`/api/v1/public/tickets/${encodeURIComponent(token)}`, {
    cache: 'no-store',
  });
  const text = await res.text();
  let body: unknown = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = text;
  }
  if (!res.ok) {
    const message =
      body && typeof body === 'object' && 'message' in body
        ? String((body as { message: unknown }).message)
        : `HTTP ${res.status}`;
    throw new Error(message);
  }
  return body as TicketPublic;
}
